const NS = 'UniqueTableName'; // jshint ignore:line

export default function UniqueTableName() {
  "ngInject";

  return {
    require: 'ngModel',
    link,
    restrict: 'A'
  };

  function link(scope, element, attrs, ngModel) {

    var validate = function (viewValue) {
      var tables = JSON.parse(attrs.uniqueTableName);

      if (!ngModel.$modelValue || !ngModel.$viewValue || !tables) {
        // It's valid because we have nothing to compare against
        ngModel.$setValidity('unique-table-name', true);
      } else {
        var name = ngModel.$modelValue.toString();
        var tableNames = tables.map(function (table) {
          return String(table.name);
        });

        var found = 0;
        var valid = true;
        for (var i = tableNames.length - 1; i >= 0; i--) {
          if (name === tableNames[i]) {
            found++;
          }
          if (found >= 2) {
            valid = false;
            break;
          }
        }

        ngModel.$setValidity('unique-table-name', valid);
      }
      return viewValue;
    };

    ngModel.$parsers.unshift(validate);
    ngModel.$formatters.push(validate);

    attrs.$observe('uniqueTableName', function () {
      // Whenever the comparison model changes we'll re-validate
      return validate(ngModel.$viewValue);
    });

  }

}
